module.exports = __webpack_public_path__ + "static/media/ios.3c9b839c.svg";